import { allowCookieConsent } from '../../actions/cookies/cookieConsent';

export const setCookieConsent = (allowCookies) => dispatch => {
  return dispatch(allowCookieConsent(allowCookies));
};



// WEBPACK FOOTER //
// ./src/client/js/store/thunks/cookies/index.js